import React from 'react';

const Flower = props => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 16C9 9 16 2 16 2C16 2 23 9 23 16C23 21 19.866 25 16 25C12.134 25 9 21 9 16Z"
        stroke="#FAB218"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M25 7.351C26.2382 6.57029 27.5308 5.87951 28.868 5.284C28.868 5.284 32.714 14.406 30.075 20.889C28.329 25.181 24.414 27.663 21 26.845"
        stroke="#FAB218"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M7.00008 7.351C5.76189 6.57029 4.46923 5.87951 3.13208 5.284C3.13208 5.284 -0.713922 14.406 1.92508 20.889C3.67108 25.181 7.58608 27.663 11.0001 26.845"
        stroke="#FAB218"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M16 31V15"
        stroke="#FAB218"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
    </svg>
  );
};

export default Flower;



// WEBPACK FOOTER //
// ./src/svg/Flower.js